export default "__VITE_ASSET__CekQjlRr__"